<template>
  <div class="order-history clearfix mg_bot50" id="open-order">
    <div class="filter-container">
      <div class="filter-item date">
        <div class="date-text">{{ $t("orders.open_order.date") }}:</div>
        <date-picker
          :disabled="disabledDatesFrom"
          v-model="startDate"
          class="date-picker-input no-right-radius"
          :format="customFormatter"
        ></date-picker>
        <date-picker
          :disabled="disabledDatesTo"
          v-model="endDate"
          class="date-picker-input no-left-radius"
          :format="customFormatter"
        ></date-picker>
      </div>
      <div class="filter-item pair">
        <div class="label-text text-pair date-text">
          {{ $t("orders.open_order.pair") }}:
        </div>
        <div class="toolbar-element2">
          <select-box
            v-model="filters.coin"
            :placeholder="$t('order.order_history.all')"
            :options="coinMasters"
          />
        </div>
        <span class="bw-element">/</span>
        <div class="toolbar-element2">
          <select-box
            v-model="filters.currency"
            :placeholder="$t('order.order_history.all')"
            :options="markets"
          />
        </div>
      </div>
      <div class="filter-item side">
        <div class="label-text date-text">
          {{ $t("orders.open_order.side") }}:
        </div>
        <div class="toolbar-element2">
          <select-box
            v-model="filters.tradeType"
            :placeholder="$t('order.order_history.all')"
            :options="tradeType"
          />
        </div>
      </div>
      <div class="filter-item">
        <input
          title
          type="text"
          :placeholder="$t('orders.open_order.search_by_email')"
          @keyup.enter="search"
          class="form-control"
          name="searchKey"
          v-model="filters.searchKey"
        />
      </div>
      <div class="filter-item btn-action">
        <BaseButton @click="search()">
          {{ $t("orders.open_order.search") }}
        </BaseButton>
        <BaseButton @click="refresh()">
          {{ $t("orders.open_order.reset") }}
        </BaseButton>
      </div>
    </div>
    <div class="datatable">
      <data-table-4
        :getData="getData"
        ref="datatable"
        :column="11"
        class="scroll"
      >
        <th data-sort-field="updated_at" class="cl1 text-left min_110">
          {{ $t("orders.open_order.time") }}
        </th>
        <th data-sort-field="email" class="cl2 min_85">
          {{ $t("orders.open_order.email") }}
        </th>
        <th data-sort-field="id" class="cl3 min_85">
          <div>{{ $t("orders.open_order.order_id") }}/</div>
          {{ $t("orders.open_order.pair") }}
        </th>
        <th data-sort-field="type" class="cl4 min_85">
          <div>{{ $t("orders.open_order.side") }}/</div>
          {{ $t("orders.open_order.type") }}
        </th>
        <th class="cl5 min_110">{{ $t("orders.open_order.average") }}</th>
        <th data-sort-field="price" class="cl6 min_110">
          <div>{{ $t("orders.open_order.price") }}/</div>
          Trigger
        </th>
        <th class="cl7 min_85">
          <div>{{ $t("orders.open_order.amount") }}/</div>
          {{ $t("orders.open_order.filled") }}
        </th>
        <th data-sort-field="fee" class="min_110">
          {{ $t("orders.open_order.fee") }}
        </th>
        <th class="cl9">{{ $t("orders.open_order.total") }}</th>
        <th class="cl10">{{ $t("orders.open_order.status") }}</th>
        <!--        <th class="cl11"></th>-->
        <template slot="body" slot-scope="props">
          <tr>
            <td
              class="text-left custom-time"
              :class="{
                'opacity-row':
                  props.item.status == 'canceled' &&
                  props.item.executed_quantity == 0,
              }"
            >
              <div>
                {{ props.item.updated_at | formatTimeStamp("YYYY-MM-DD") }}
              </div>
              <div>
                {{ props.item.updated_at | formatTimeStamp("HH:mm:ss") }}
              </div>
            </td>
            <td
              class="cl2"
              :class="{
                'opacity-row':
                  props.item.status == 'canceled' &&
                  props.item.executed_quantity == 0,
              }"
            >
              <div class="item_email_user">
                <span class="txt_email_user">{{ props.item.email }}</span>
                <span class="tooltip_email_user">{{ props.item.email }}</span>
              </div>
            </td>
            <td
              class="custom-order-id"
              :class="{
                'opacity-row':
                  props.item.status == 'canceled' &&
                  props.item.executed_quantity == 0,
              }"
            >
              <div class="item_order_id">
                <span class="txt_order_id">{{ props.item.id }}</span>
                <span class="tooltip_order_id">{{ props.item.id }}</span>
              </div>
              <div>
                {{ props.item.coin | uppercase }}/{{
                  props.item.currency | uppercase
                }}
              </div>
            </td>
            <td
              class="cl4"
              :class="{
                'opacity-row':
                  props.item.status == 'canceled' &&
                  props.item.executed_quantity == 0,
              }"
            >
              <div
                :class="{
                  buy: props.item.trade_type === 'BUY',
                  sell: props.item.trade_type === 'SELL',
                }"
              >
                {{ props.item.trade_type | uppercaseFirst }}
              </div>
              <div>{{ props.item.type | uppercaseFirst }}</div>
            </td>
            <td
              class="cl5"
              :class="{
                'opacity-row':
                  props.item.status == 'canceled' &&
                  props.item.executed_quantity == 0,
              }"
            >
              <span v-if="props.item.custom_status === 'Pending'"> - </span>
              <span v-else>{{
                props.item.executed_price
                  | formatCurrencyAmount(props.item.currency, "auto")
              }}</span>
            </td>
            <td
              class="cl6"
              :class="{
                'opacity-row':
                  props.item.status == 'canceled' &&
                  props.item.executed_quantity == 0,
              }"
            >
              <span
                v-if="
                  props.item.type == 'market' ||
                  props.item.type == 'stop_market'
                "
                >{{ $t("orders.open_order.market") }}</span
              >
              <span v-else>{{
                props.item.price
                  | formatCurrencyAmount(props.item.currency, "auto")
              }}</span>
            </td>
            <td
              class="cl7"
              :class="{
                'opacity-row':
                  props.item.status == 'canceled' &&
                  props.item.executed_quantity == 0,
              }"
            >
              <div>
                {{
                  props.item.quantity
                    | formatCurrencyAmount(props.item.coin, "auto")
                }}
              </div>
              <div>
                {{
                  props.item.executed_quantity
                    | formatCurrencyAmount(props.item.coin, "auto")
                }}
              </div>
            </td>
            <td
              class="cl8"
              :class="{
                'opacity-row':
                  props.item.status == 'canceled' &&
                  props.item.executed_quantity == 0,
              }"
            >
              <span v-if="props.item.custom_status === 'Pending'"> - </span>
              <span v-else-if="props.item.trade_type === 'buy'">{{
                props.item.fee | formatCurrencyAmount(props.item.coin, "auto")
              }}</span>
              <span v-else>{{
                props.item.fee
                  | formatCurrencyAmount(props.item.currency, "auto")
              }}</span>
            </td>
            <td
              class="cl9"
              :class="{
                'opacity-row':
                  props.item.status == 'canceled' &&
                  props.item.executed_quantity == 0,
              }"
            >
              <span
                v-if="
                  props.item.type == 'market' ||
                  props.item.type == 'stop_market'
                "
                >0</span
              >
              <span v-else>{{
                props.item.price
                  | mulBigNumber(props.item.quantity)
                  | formatCurrencyAmount(props.item.currency, "auto")
              }}</span>
            </td>
            <td
              class="cl10"
              :class="{
                'opacity-row':
                  props.item.status == 'canceled' &&
                  props.item.executed_quantity == 0,
              }"
            >
              {{ props.item.custom_status }}
            </td>
            <!--            <td class="cl11" :class="{'opacity-row': props.item.status == 'canceled' && props.item.executed_quantity == 0}">-->
            <!--              <button-->
            <!--                type="button"-->
            <!--                class="btn btn-detail"-->
            <!--                @click="viewDetail(props.item.id, props.item.trade_type)"-->
            <!--                :disabled="props.item.status == 'canceled' && props.item.executed_quantity == 0"-->
            <!--              >{{ $t('orders.order_history.view_detail') }}</button>-->
            <!--            </td>-->
          </tr>
        </template>
      </data-table-4>
    </div>
    <modal
      name="orderDetailModal"
      :title="$t('orders.order_history.trade_history')"
    >
      <div slot="body" class="body-popup" style="font-size: 10pt">
        <data-table :getData="getTradeHistory" :column="9" class="scroll">
          <th data-sort-field="order_Id" class="text-c">
            {{ $t("orders.order_history.order_id") }}
          </th>
          <th data-sort-field="created_at">
            {{ $t("orders.order_history.date") }}
          </th>
          <th data-sort-field="Email">
            {{ $t("orders.order_history.email") }}
          </th>
          <th data-sort-field="pair">{{ $t("orders.order_history.pair") }}</th>
          <th data-sort-field="transaction_type">
            {{ $t("orders.order_history.side") }}
          </th>
          <th data-sort-field="price">
            {{ $t("orders.order_history.price") }}
          </th>
          <th data-sort-field="quantity">
            {{ $t("orders.order_history.filled") }}
          </th>
          <th data-sort-field="Fee">{{ $t("orders.order_history.fee") }}</th>
          <th data-sort-field="amount">
            <span>{{ $t("orders.order_history.total") }}</span>
          </th>
          <template slot="body" slot-scope="props">
            <tr>
              <td class="f-td">
                <span>{{ props.item.order_Id }}</span>
              </td>
              <td>{{ props.item.created_at | timestampToDate }}</td>
              <td>
                <span class="text-wrap">{{ props.item.Email }}</span>
              </td>
              <td>
                {{ props.item.coin | uppercase }}/{{
                  props.item.currency | uppercase
                }}
              </td>
              <td v-if="props.item.transaction_type == 'buy'" class="type-buy">
                {{ props.item.transaction_type | tradeType }}
              </td>
              <td v-else class="type-sell">
                {{ props.item.transaction_type | tradeType }}
              </td>
              <td>
                <span
                  class="text-wrap"
                  v-if="
                    props.item.type == 'market' ||
                    props.item.type == 'stop_market'
                  "
                  >Market</span
                >
                <span class="text-wrap" v-else>{{
                  props.item.price
                    | convertToBigNumber
                    | formatCurrencyAmount(props.item.currency, "auto")
                }}</span>
              </td>
              <td>
                {{
                  props.item.quantity | formatCurrencyAmount(props.item.coin)
                }}
              </td>
              <td>
                <span>{{
                  props.item.Fee | formatCurrencyAmount(props.item.coin, "auto")
                }}</span>
              </td>
              <td>
                {{ props.item.amount | formatCurrencyAmount(props.item.coin) }}
              </td>
            </tr>
          </template>
        </data-table>
      </div>
      <div slot="footer"></div>
    </modal>
    <loading-modal />
  </div>
</template>

<script>
import rf from "../../lib/RequestFactory";
import Modal from "../../components/Modal";
import DatePicker from "vuejs-datepicker";
import moment from "moment";
import SelectBox from "../../components/SelectBox";
import DataTable4 from "../../components/DataTable4";
import BaseButton from "@/common/Button.vue";
import LoadingModal from "@/modals/common/LoadingModal.vue";
export default {
  components: {
    Modal,
    DatePicker,
    SelectBox,
    DataTable4,
    BaseButton,
    LoadingModal,
  },
  data() {
    return {
      titlePage: window.i18n.t("orders.open_order.open_order"),
      startDate: moment().subtract(6, "days").toDate(),
      endDate: new Date(),
      coin: "",
      filters: {
        coin: "",
        currency: "",
        tradeType: "",
        searchKey: "",
      },
      idDetail: null,
      coinMasters: [],
      trades: [],
      tradeType: [
        { id: "ALL", name: window.i18n.t("orders.open_order.all") },
        { id: "BUY", name: window.i18n.t("orders.open_order.buy") },
        { id: "SELL", name: window.i18n.t("orders.open_order.sell") },
      ],
      tradeTypeId: null,
      markets: [],
    };
  },
  computed: {
    disabledDatesFrom() {
      const disabled = {};
      const today = new Date();
      today.setHours(23, 59, 59, 999);

      disabled.from = new Date(today.getTime() + 1);

      if (this.endDate) {
        const endDateCopy = new Date(this.endDate);
        endDateCopy.setHours(23, 59, 59, 999);

        if (endDateCopy < today) {
          disabled.from = new Date(endDateCopy.getTime() + 1);
        }
      }

      return disabled;
    },
    disabledDatesTo() {
      const disabled = {};
      const today = new Date();
      today.setHours(23, 59, 59, 999);

      disabled.from = new Date(today.getTime() + 1);

      if (this.startDate) {
        const startDateCopy = new Date(this.startDate);
        startDateCopy.setHours(0, 0, 0, 0);
        disabled.to = new Date(startDateCopy.getTime() - 1);
      }

      return disabled;
    },
  },
  watch: {
    "filters.currency"(newValue) {
      if (newValue && newValue.id) {
        this.requestCoinListByCurrency(newValue.id);
        this.filters.coin = "";
      }
    },
  },
  methods: {
    search() {
      let filterParams = {
        startDate: moment(this.startDate).startOf("day").toISOString(),
        endDate: moment(this.endDate).endOf("day").toISOString(),
      };
      if (this.startDate > this.endDate) {
        this.$toastr("error", this.$t("common.date.warning"));
        return;
      }
      if (this.filters.searchKey) {
        filterParams.searchKey = this.filters.searchKey;
      }
      if (this.filters.coin && this.filters.coin.id != "ALL") {
        filterParams.coin = this.filters.coin.id.toLowerCase();
      }
      if (this.filters.currency && this.filters.currency.id != "all") {
        filterParams.currency = this.filters.currency.id;
      }
      if (this.filters.tradeType && this.filters.tradeType.id != "all") {
        filterParams.tradeType = this.filters.tradeType.id;
      }
      this.$refs.datatable.filter(filterParams);
    },
    refresh() {
      this.requestCoinList();
      this.resetInput();
      this.$refs.datatable.refresh();
    },
    resetInput() {
      this.filters = Object.assign(this.filters, {
        coin: "",
        currency: "",
        tradeType: "",
        searchKey: "",
      });
      this.startDate = moment().subtract(6, "days").toDate();
      this.endDate = new Date();
    },
    getData(params) {
      this.$modal.show("modal-loading");
      const defaultParams = {
        startDate: this.startDate
          ? moment(this.startDate).startOf("day").toISOString()
          : undefined,
        endDate: this.endDate
          ? moment(this.endDate).endOf("day").toISOString()
          : undefined,
      };

      const finalParams = Object.entries({
        ...defaultParams,
        ...params,
      }).reduce(
        (acc, [key, value]) =>
          value != null && value !== "" ? { ...acc, [key]: value } : acc,
        {}
      );

      return rf
        .getRequest("OrderRequest")
        .getOrdersPending(finalParams)
        .finally(() => {
          this.$modal.hide("modal-loading");
        });
    },
    /*
    getMarkets() {
      return window._.map(COMMON_CONST.MARKETS, item => {
        return { id: item, name: item.toUpperCase() };
      });
    },
    */
    requestCoinList() {
      rf.getRequest("CoinSettingRequest")
        .getCoinList()
        .then((res) => {
          const resultCoins = res.data.filter((item) => item?.coin !== "usd");
          const coinList = window._.map(resultCoins, (item) => ({
            id: item.coin,
            name: item.coin.toUpperCase(),
          }));
          this.coinMasters = [
            { id: "ALL", name: window.i18n.t("orders.open_order.all") },
            ...coinList,
          ];
        });
    },
    requestCoinListByCurrency(currency) {
      const currencyParam = currency === "all" ? "" : currency;
      rf.getRequest("AdminRequest")
        .getPriceGroupCurrencyCoins(currencyParam)
        .then((res) => {
          const data = res.data || res;
          if (data && Array.isArray(data)) {
            const resultCoins = data.filter((item) => item?.coin !== "usd");
            const uniqueCoins = [
              ...new Set(resultCoins.map((item) => item.coin)),
            ];
            const coinList = uniqueCoins.map((coin) => ({
              id: coin,
              name: coin.toUpperCase(),
            }));
            this.coinMasters = [
              { id: "ALL", name: window.i18n.t("orders.open_order.all") },
              ...coinList,
            ];
          }
        })
        .catch((error) => {
          console.error("Error loading coins:", error);
          this.requestCoinList();
        });
    },
    viewDetail(id, tradeType) {
      this.tradeTypeId = tradeType;
      this.idDetail = id;
      $("body").addClass("modal-open");
      CommonModal.show("orderDetailModal", {
        position: "center",
        mask: true,
        buttons: [
          {
            label: "OK",
            focused: true,
            style: {
              width: "140px",
              background: "rgb(0, 112, 192)",
            },
            callback: () => {
              CommonModal.hide("orderDetailModal");
            },
          },
        ],
      });
    },

    getTradeHistory(params) {
      let orderId = this.idDetail;
      params["tradeType"] = this.tradeTypeId;
      return rf.getRequest("OrderRequest").getTradeByOrder(orderId, params);
    },
    customFormatter(date) {
      return moment(date).format("YYYY - MM - DD");
    },
  },

  mounted() {
    this.$modal.show("modal-loading");
    this.$emit("EVENT_PAGE_CHANGE", this);
    this.requestCoinList();
  },
  created() {
    rf.getRequest("AdminRequest")
      .getPriceGroupCurrency()
      .then((res) => {
        try {
          this.markets.push({
            id: "all",
            name: window.i18n.t("orders.open_order.all"),
          });
          const data = res.data || res;
          const uniqueCurrencies = [
            ...new Set(data.map((item) => item.currency)),
          ];
          uniqueCurrencies.forEach((currency) => {
            if (typeof currency !== "undefined" && currency !== "usd") {
              this.markets.push({
                id: currency,
                name: currency.toUpperCase(),
              });
            }
          });
        } catch (ex) {
          console.error(ex);
        }
      });
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/variables";

.date-picker-input {
  display: inline-block;
  input {
    padding: 0 5px 0px 30px;
    width: 110px;
    border-radius: 3px;
    -webkit-box-shadow: none;
    box-shadow: none;
    height: 30px;
    line-height: 30px;
    border: 1px solid #d2d6de;
    background-image: url("@/assets/images/icon/date-time.svg") !important;
    background-color: $color-white-smoke !important;
    background-size: 12px;
    background-position: center left 5px;
    background-repeat: no-repeat !important;
    color: $color-grey-dusty;
    &:hover,
    &:active,
    &:focus {
      border-color: $color-jungle-green;
      z-index: 9;
    }
  }
}
.no-left-radius {
  input {
    border-radius: 0px 3px 3px 0px;
    margin-left: -1px;
  }
}
.no-right-radius {
  input {
    border-radius: 3px 0px 0px 3px;
  }
}
.modal-content .modal-footer {
  text-align: center;
  margin-top: 30px;
}
#open-order {
  font-family: $mulish-regular;
  .sc_search_select {
    .group_search_select {
      .button_drop_search {
        height: 30px !important;
        padding: 5px 10px 5px 10px !important;
        border-radius: 3px;
        margin-right: 20px;
        font-size: $font-small !important;
        font-family: $mulish-regular;
        span {
          font-size: $font-small;
        }
        i.icon-arrow1 {
          margin-left: 5px;
          color: $color_dove_gray;
        }
        &:hover {
          border-color: $color-jungle-green;
          i.icon-arrow1 {
            color: $color-jungle-green;
          }
        }
      }
      .box_list_search_select {
        .list_search_select {
          li {
            font-family: $mulish-regular;
            font-size: $font-small;
            &:hover,
            &:active,
            &:focus {
              color: $color-jungle-green;
            }
          }
        }
      }
    }
  }

  .modal-dialog {
    min-width: 80%;
    min-height: 400px;
    position: relative;
    top: -10%;
  }
  .modal-content {
    min-height: 400px;
    .modal-footer {
      text-align: center;
      margin-top: 30px;
    }
    .modal-header {
      padding: 30px 16px 16px 20px;
      .modal-title {
        font-family: "Mulish-Medium", sans-serif;
        font-size: 18px;
        font-weight: 500;
        color: $color-grey-dark;
        text-transform: none;
      }
    }
    .modal-body {
      padding: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "@/assets/sass/variables";
// .min_85 {
//   min-width: 85px;
// }
// .min_110 {
//   min-width: 110px;
// }
.w_125 {
  width: 125px;
}
.item_email_user {
  display: inline-block;
  float: left;
  position: relative;
  .txt_email_user {
    display: block;
    max-width: 65px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .tooltip_email_user {
    position: absolute;
    top: 0px;
    left: 0px;
    line-height: 20px;
    padding: 5px 20px;
    left: 100%;
    background-color: $color_white;
    white-space: nowrap;
    width: auto;
    z-index: 10;
    font-size: $font_root;
    font-weight: 500;
    color: $color_mine_shaft;
    transition: 0.5s;
    display: none;
    box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4);
    &:after {
      right: 100%;
      top: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-right-color: $color_white;
      border-width: 5px;
      margin-top: -5px;
    }
  }
  &:hover {
    .tooltip_email_user {
      display: block;
      transition: 0.5s;
    }
  }
}
.text-left {
  text-align: left;
}
.date-text {
  font-size: $font-small;
  color: $color-grey-dusty;
  font-family: $mulish-regular;
}
body.modal-open {
  overflow: hidden;
}
.body-popup {
  max-height: 400px;
  overflow-y: auto;
  table {
    thead {
      th:last-child {
        text-align: right;
        padding: 5px 20px 0px 15px !important;
        span {
          float: right;
        }
      }

      th {
        // text-align: center;
        padding: 5px 0px 0px 15px !important;
        color: $color_grey;
      }
    }
    tbody {
      tr {
        td:last-child {
          text-align: right;
          padding-right: 18px !important;
        }
        td:first-child {
          min-width: 82px;
        }
        td:nth-child(2) {
          min-width: 170px;
        }
        td:nth-child(3) {
          min-width: 250px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        td:nth-child(4) {
          min-width: 120px;
        }
        td:nth-child(5) {
          min-width: 70px;
        }
        td:nth-child(6) {
          min-width: 90px;
        }
        td:nth-child(7) {
          min-width: 100px;
        }
        td:nth-child(8) {
          min-width: 120px;
        }
        td:nth-child(9) {
          min-width: 100px;
        }
        td {
          // text-align: center;
          padding-top: 5px;
          &.type-buy {
            color: $color-jungle-green;
          }
          &.type-sell {
            color: $color_red_text;
          }
        }
      }
    }
  }
}
.empty-data {
  text-align: center;
  padding-top: 15px !important;
  color: $color_grey;
  font-size: 14px;
  background-color: $color_white;
}
.opacity-row {
  opacity: 0.4;
}
.text-wrap {
  word-wrap: break-word;
}
.checkbox {
  margin-top: 0px;
  display: inline-block;
  font-size: 14px;
  margin-bottom: 0px;
  font-weight: normal;
  height: 30px;
  line-height: 30px;
  input[type="checkbox"] {
    display: none;
  }
  span {
    position: relative;
    content: "";
    display: inline-block;
    border: 1px solid $color_alto;
    width: 16px;
    height: 16px;
    top: 3px;
    left: 8px;
    border-radius: 2px;
    margin-right: 8px;
    position: relative;
    background-color: $color_white;
  }
  input:checked {
    & + span {
      &:after {
        opacity: 0.9;
        content: "";
        position: absolute;
        width: 14px;
        height: 7px;
        background: transparent;
        top: 2px;
        left: 0px;
        border: 3px solid #0090eb;
        border-top: none;
        border-right: none;
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
      }
    }
  }
}

.order-history {
  .filter-container {
    margin: 10px 0;
    height: 60px;
    .filter-item {
      float: left;
      margin: 0 5px;
      input {
        margin-top: 18px;
        display: inline-block;
        width: 145px;
        &:hover,
        &:active,
        &:focus {
          border-color: $color-jungle-green;
        }
      }
      select {
        width: 65px;
        display: inline-block;
        font-family: $mulish-regular;
        font-size: $font_root;
        &:hover,
        &:active,
        &:focus {
          border-color: $color-jungle-green;
        }
      }
      button {
        margin: 0 5px;
        width: auto;
        margin-top: 18px;
        height: 30px;
        font-size: $font-smaller;
        font-family: $mulish-regular;
      }
      .btn-reset {
        font-size: $font-smaller;
        border-radius: 3px;
        border: 1px solid #b7ff03;
        width: 80px;
        color: #000000;
        text-transform: uppercase;
        background-color: #b7ff03;
        font-weight: 500;
        &:hover {
          background-color: #c1ff28;
          border-color: #c1ff28;
        }
      }
      .btn-primary {
        padding: 0;
        background-color: #b7ff03;
        font-size: $font-smaller;
        &:hover {
          background-color: #c1ff28;
          border-color: #c1ff28;
        }
      }
      .coin-input {
        position: relative;
        display: inline-block;
        margin: 0 5px;
        margin-right: 0px;
        .coin-option {
          background-color: $color-white;
          max-height: 210px;
          display: block;
          overflow-y: auto;
          margin-top: 5px;
          position: absolute;
          width: 79px;
          left: 5px;
          z-index: 10;
          padding: 12px 0px;
          box-shadow: 0px 3px 12px rgba(49, 49, 49, 0.51);
          &:after {
            bottom: 100%;
            left: 50%;
            border: solid transparent;
            content: " ";
            display: block;
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            border-color: rgba(136, 183, 213, 0);
            border-bottom-color: $color_white;
            border-width: 5px;
            margin-left: -5px;
          }
          .option {
            display: block;
            width: 100%;
            line-height: 20px;
            cursor: pointer;
            padding: 3px 14px;
            overflow: hidden;
            &:hover {
              color: $color-jungle-green;
            }
          }
          .no-data {
            display: block;
            width: 100%;
            line-height: 20px;
            padding: 3px 14px;
            text-align: center;
            color: $color-grey-dusty;
            font-size: $font-small;
          }
        }
      }
    }
    .text-pair {
      // padding-left: 10px;
    }
  }
  .form-control {
    background: $color-white-smoke;
    height: 30px;
    font-size: 13px;
    padding-left: 11px;
    padding-right: 0;
  }
  .datatable {
    button.btnForm.bt-action {
      padding-left: 5px !important;
      padding-right: 5px !important;
      font-weight: 400 !important;
    }
  }
  .buy {
    color: $text-color-jade;
  }
  .sell {
    color: $text-color-red;
  }
  .btn-detail {
    background-color: $color-caribbean-green;
    padding: 2px 10px;
    font-size: $font-smaller;
    color: $color-white;
    border: 1px solid $color-caribbean-green;
    border-radius: 3px;
    text-transform: uppercase;
    font-family: $mulish-regular;
    &:hover {
      background-color: $color-aquamarine;
      border-color: $color-aquamarine;
    }
  }
  .icon-notfound {
    font-size: 40px;
    padding-right: 15px;
  }
  .toolbar-element2 {
    display: inline-block;
    float: left;
  }
  .bw-element {
    float: left;
    font-size: 15px;
    margin-left: 5px;
    height: 30px;
    line-height: 30px;
    margin-right: 5px;
    color: $color-grey-dusty;
  }
  td.cl1 {
    min-width: 115px;
  }
  td.cl2 {
    min-width: 105px;
  }
  td.cl3 {
    min-width: 110px;
  }
  td.cl4 {
    min-width: 85px;
  }
  td.cl5 {
    min-width: 98px;
  }
  td.cl6,
  td.cl7,
  td.cl8,
  td.cl9 {
    min-width: 115px;
  }
  td.cl10 {
    min-width: 120px;
  }
  td.cl11 {
    min-width: 100px;
  }
  .custom-time {
    min-width: 125px;
  }
  .custom-order-id {
    width: 200px;
  }
}

.item_email_user {
  display: inline-block;
  float: left;
  position: relative;
  .txt_email_user {
    display: block;
    max-width: 85px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .tooltip_email_user {
    position: absolute;
    top: 0px;
    left: 0px;
    line-height: 20px;
    padding: 5px 20px;
    left: 100%;
    background-color: $color_white;
    white-space: nowrap;
    width: auto;
    z-index: 10;
    font-size: $font_root;
    font-weight: 500;
    color: $color_mine_shaft;
    transition: 0.5s;
    display: none;
    box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4);
    &:after {
      right: 100%;
      top: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-right-color: $color_white;
      border-width: 5px;
      margin-top: -5px;
    }
  }
  &:hover {
    .tooltip_email_user {
      display: block;
      transition: 0.5s;
    }
  }
}

.item_order_id {
  display: inline-block;
  float: left;
  position: relative;
  .txt_order_id {
    display: block;
    max-width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .tooltip_order_id {
    position: absolute;
    top: 0px;
    left: 0px;
    line-height: 20px;
    padding: 5px 20px;
    left: 100%;
    background-color: $color_white;
    white-space: nowrap;
    width: auto;
    z-index: 10;
    font-size: $font_root;
    font-weight: 500;
    color: $color_mine_shaft;
    transition: 0.5s;
    display: none;
    box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4);
    &:after {
      right: 100%;
      top: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-right-color: $color_white;
      border-width: 5px;
      margin-top: -5px;
    }
  }
  &:hover {
    .tooltip_order_id {
      display: block;
      transition: 0.5s;
    }
  }
}
</style>
